module.exports = __webpack_public_path__ + "files/a2e0522575c10759bcf3332c5db0260f.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Caligraphic-Bold.woff2
// module id = 1410
// module chunks = 59